module.exports = __webpack_public_path__ + "static/media/navantiaButton.aecacdc7.png";